import type { ReactNode } from "react";
import "./PageHeader.css";

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  /** A control aligned to the header's trailing edge — "Approve run", the
   *  Cash/Accrual toggle, etc. Optional: not every screen needs one. */
  action?: ReactNode;
}

/**
 * The plain `<h1>` + subtitle + optional action row every screen but the
 * Dashboard uses — matches the design spec's `.head`. Dashboard keeps its own
 * horizon-banner header (ADR 0004: that gesture is deliberately unique to it),
 * so this is everything else.
 */
export function PageHeader({ title, subtitle, action }: PageHeaderProps) {
  return (
    <div className="page-header">
      <div>
        <h1 className="page-header__title">{title}</h1>
        {subtitle && <p className="page-header__subtitle">{subtitle}</p>}
      </div>
      {action && <div className="page-header__action">{action}</div>}
    </div>
  );
}
